import { useEffect, useState } from 'react'

// Keep in sync with public/ds/tokens/breakpoints.css.
export const BREAKPOINTS = { phone: 640, tablet: 900, desktop: 1100 }

// True while `query` matches. SSR-safe: false until mounted in a browser.
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(false)
  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])
  return matches
}
